/**
 * Created by Jerker Nord on 2021-11-08.
 */

import {TrueGritGritGirlSymbol} from "../reels/TrueGritGritGirlSymbol";
import {ISymbolPosition} from "../../core/reel/ReelInterfaces";
import {TrueGrit} from "../TrueGrit";
import {gsap} from "gsap";
import {TrueGritReelStopAnimationRunner} from "../presentationrunners/maingame/TrueGritReelStopAnimationRunner";

export class TrueGritGritGirlSymbols {

    private _gritGirlSymbols:TrueGritGritGirlSymbol[];

    public init():void {
        this._gritGirlSymbols = [];
        for(let i:number = 0; i < 9; i++) {
            let tempGritGirl = new TrueGritGritGirlSymbol("M0");
            this._gritGirlSymbols.push(tempGritGirl);
        }
    }

    public getGritGirlSymbol(symbolPositionData:ISymbolPosition):TrueGritGritGirlSymbol {
        for(let i:number = 0; i < this._gritGirlSymbols.length; i++) {
            if(!this._gritGirlSymbols[i].isUsed) {
                this._gritGirlSymbols[i].isUsed = true;
                this._gritGirlSymbols[i].isRemoved = false;
                this._gritGirlSymbols[i].resetSplitLevel();
                this._gritGirlSymbols[i].reelId = symbolPositionData.reelId;
                this._gritGirlSymbols[i].reelPosition = symbolPositionData.startPosition;
                this._gritGirlSymbols[i].reelTargetPosition = symbolPositionData.targetPosition;
                this.setMultiplierOnAllActiveSyms(TrueGrit.model.botTrain.wildMult);
                if(this.getGritGirlsLanded() > 2) {
                    this._gritGirlSymbols[i].showEnabledMultiplier();
                } else {
                    this._gritGirlSymbols[i].showDisabledMultiplier();
                }
                return this._gritGirlSymbols[i];
            }
        }
        throw new Error("TrueGritGritGirlSymbols: No Grit Girls left in the pool!");
    }

    public getGritGirlsLanded():number {
        let landed:number = 0;
        for(let i:number = 0; i < this._gritGirlSymbols.length; i++) {
            if(this._gritGirlSymbols[i].landedInThisRound) {
                landed++;
            }
        }
        return landed;
    }

    public play2GirlsLandedAnimation():void {
        TrueGritReelStopAnimationRunner.reelStopAnimationStarted();
        const twoLandedTimeline:gsap.core.Timeline = gsap.timeline();
        twoLandedTimeline.add(() => {
            for(let i:number = 0; i < this._gritGirlSymbols.length; i++) {
                if(this._gritGirlSymbols[i].landedInThisRound) {
                    this._gritGirlSymbols[i].symbolName = "M0_2";
                    this._gritGirlSymbols[i].setCurrentStateSpriteTexture();
                    this._gritGirlSymbols[i].showEnabledMultiplier();
                }
            }
        }, 0.1);
        twoLandedTimeline.add(() => TrueGritReelStopAnimationRunner.reelStopAnimationStopped(), "+=0.8");
    }

    public playMoreThan2GirlsLandedAnimation():void {
        TrueGritReelStopAnimationRunner.reelStopAnimationStarted();
        const threeLandedTimeline:gsap.core.Timeline = gsap.timeline();
        threeLandedTimeline.add(() => {
            for(let i:number = 0; i < this._gritGirlSymbols.length; i++) {
                if(this._gritGirlSymbols[i].landedInThisRound) {
                    this._gritGirlSymbols[i].symbolName = "M0_3";
                    this._gritGirlSymbols[i].setCurrentStateSpriteTexture();
                    this._gritGirlSymbols[i].showEnabledMultiplier();
                }
            }
        }, 0.1);
        threeLandedTimeline.add(() => TrueGritReelStopAnimationRunner.reelStopAnimationStopped(), "+=0.8");
    }

    public setMultiplierOnAllActiveSyms(multiplier:number):void {
        for(let i:number = 0; i < this._gritGirlSymbols.length; i++) {
            if(this._gritGirlSymbols[i].isUsed) {
                this._gritGirlSymbols[i].setMultiplierText(multiplier);
            }
        }
    }

    public getAllUsedGritGirls():TrueGritGritGirlSymbol[] {
        return this._gritGirlSymbols.filter((sym:TrueGritGritGirlSymbol) => sym.isUsed);
    }

    // it should happen for only 2 used symbols.
    public goBackAllToOffState():void {
        const symbols:TrueGritGritGirlSymbol[] = this.getAllUsedGritGirls();

        if(symbols.length === 2) {
            symbols[0].resetState(0.75);
            symbols[1].resetState(0.75);
        }
    }
}